import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface SplitNavigationProps {
  onNext: () => void;
  onPrev: () => void;
  disabled?: boolean;
  colors?: {
    accent?: string;
    accentText?: string;
    backText?: string;
  };
}

const SplitNavigation: React.FC<SplitNavigationProps> = ({
  onNext,
  onPrev,
  disabled = false,
  colors = {},
}) => {
  const { t } = useTranslation();
  const accent = colors.accent || '#DDB889';
  const accentText = colors.accentText || '#1C1208';
  const backText = colors.backText || '#A09382';

  return (
    <div
      className="lp-flex lp-items-center lp-justify-between lp-pt-8 lp-mt-auto"
      style={{ borderTop: '1px solid rgba(0,0,0,0.07)' }}
    >
      <button
        onClick={onPrev}
        className="lp-text-sm lp-tracking-widest lp-uppercase lp-transition-opacity hover:lp-opacity-100"
        style={{ color: backText, opacity: 0.6 }}
      >
        ← {t('common.back', 'Back')}
      </button>

      <motion.button
        onClick={!disabled ? onNext : undefined}
        disabled={disabled}
        className="lp-flex lp-items-center lp-gap-3 lp-px-8 lp-py-3 lp-rounded-full lp-text-sm lp-font-medium lp-tracking-widest lp-uppercase"
        style={{
          backgroundColor: disabled ? 'rgba(221,184,137,0.15)' : accent,
          color: disabled ? 'rgba(180,150,100,0.5)' : accentText,
          cursor: disabled ? 'not-allowed' : 'pointer',
          transition: 'background-color 0.25s ease, color 0.25s ease',
        }}
        whileHover={!disabled ? { scale: 1.03 } : {}}
        whileTap={!disabled ? { scale: 0.97 } : {}}
      >
        {t('common.continue', 'Continue')}
        <ArrowRight size={15} />
      </motion.button>
    </div>
  );
};

export default SplitNavigation;
